import React, { createContext, useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider, createGlobalStyle } from 'styled-components';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { getItem, storeItem } from '#/shared/utils/storage';
import { LIGHT_THEME, DARK_THEME, LEGACY_THEME } from '#/user/themes';
import { THEME_MODE_KEY } from '#/shared/constants';

export const ThemeContext = createContext(LEGACY_THEME);
export const SetThemeContext = createContext(null);

const GlobalStyle = createGlobalStyle`
  body {
    background-color: ${props => props.theme.backgroundColor};
    color: ${props => props.theme.primaryFontColor};
  }
`;
const DEFAULT_THEME = LEGACY_THEME;
const themes = [LEGACY_THEME, LIGHT_THEME, DARK_THEME];
const themeLookup = themes.reduce((lookup, theme) => {
  return {
    ...lookup,
    [theme.name]: theme,
  };
}, {});

const getInitialTheme = () => {
  // TODO: Remove comment on saved theme look up and system dark mode check,
  // as well as eslint-disable above when theme is fully implemented, also
  // build out unit tests to confirm it returns the correct value when neither
  // savedTheme or prefersDarkMode are set, when only one or the other are set,
  // and when both are set. https://trimet.atlassian.net/browse/PRJ77-473

  /*
  const savedTheme = getItem(THEME_MODE_KEY);
  if (savedTheme) {
    return themeLookup[savedTheme] || DEFAULT_THEME;
  }

  if (typeof window !== 'undefined') {
    const prefersDarkMode = window.matchMedia(
      '(prefers-color-scheme: dark)'
    ).matches;
    return prefersDarkMode ? DARK_THEME : LIGHT_THEME;
  }
  */
  return DEFAULT_THEME; // For now, defaulting to DEFAULT theme. We will sunset LEGACY theme eventually.
};

export default function ThemeContainer({ children }) {
  const [theme, setTheme] = useState(getInitialTheme);

  // TODO: Remove comment on useEffect when theme is fully implemented
  /*
  useEffect(() => {
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    const handleChange = e => {
      const savedTheme = getItem(THEME_MODE_KEY);
      if (!savedTheme) {
        setTheme(e.matches ? DARK_THEME : LIGHT_THEME);
      }
    };
    mediaQuery.addEventListener('change', handleChange);
    return () => {
      mediaQuery.removeEventListener('change', handleChange);
    };
  }, []);
  */

  const toggleTheme = useCallback(themeName => {
    setTheme(themeLookup[themeName] || DEFAULT_THEME);
    storeItem(THEME_MODE_KEY, themeName);
  }, []);

  return (
    <SetThemeContext.Provider value={toggleTheme}>
      <ThemeContext.Provider value={theme}>
        <ThemeProvider theme={theme}>
          <GlobalStyle />
          {children}
        </ThemeProvider>
      </ThemeContext.Provider>
    </SetThemeContext.Provider>
  );
}

ThemeContainer.propTypes = {
  children: PropTypes.node.isRequired,
};
